<ml-set-wallpaper-ui (wallpaper)="setWallpaper($event)"></ml-set-wallpaper-ui>